<template>
  <div>
    <div>
      <p class="sheet-title">{{ $t('purchasing_notice_title') }}</p>
      <content-show-more v-model="shouldAllShow" :hide="!shouldMoreInfoButtonShow" class-name="mt-4 mb-0">
        <div
          id="productShoppingNotice__sheetContent"
          ref="shoppingNoticeRef"
          class="sheet-content"
          :class="shouldAllShow ? 'wd-line-clamp-none' : 'wd-line-clamp-10'"
        >
          <!-- Must have div below to prevent content overlap -->
          <div>
            <ContentData v-for="(data, idx) in shoppingNoticesUiData" :key="idx" v-bind="data" />
          </div>
        </div>
      </content-show-more>
    </div>
  </div>
</template>

<script>
import { ProductDetailHtmlType } from '@/view-models/product'
import ContentShowMore from '@/components/ContentShowMore.vue'
import ContentData from '@/components/ContentData.vue'

export default defineComponent({
  name: 'ProductShoppingNotice',
  components: {
    ContentShowMore,
    ContentData,
  },
  props: {
    shoppingNotices: { type: Array, default: () => [] },
  },
  data() {
    return {
      shouldAllShow: false,
      shouldMoreInfoButtonShow: false,
      ProductDetailHtmlType: ProductDetailHtmlType,
    }
  },
  computed: {
    shoppingNoticesUiData() {
      return this.shoppingNotices.map(item => ({
        type: item.type,
        meta: item.meta,
        list: item.attr?.list || [],
        mediaWidth: item.attr?.width || 0,
        mediaHeight: item.attr?.height || 0,
      }))
    },
  },
  mounted() {
    this.setShouldMoreInfoButtonShow()
  },
  methods: {
    setShouldMoreInfoButtonShow() {
      // 220px is 22(line-height) x 10(lines). But it will be 218px in Safari, set it to 200(> 22 x 9).
      this.shouldMoreInfoButtonShow = this.$refs.shoppingNoticeRef?.getBoundingClientRect().height >= 200
    },
  },
})
</script>

<style lang="scss" scoped>
.sheet-content {
  overflow: hidden;
  text-overflow: ellipsis;
  :deep(strong) {
    line-height: 1em;
  }
  :deep(p) {
    margin-bottom: 0px;
  }
  :deep(*) {
    line-height: 22px;
  }

  @include xxs {
    &#productShoppingNotice__sheetContent {
      margin-bottom: 6px;
    }
  }
}
</style>
